import React, { useState, useContext } from "react";
import { db } from "../firebase";
import { deleteDoc, doc } from "firebase/firestore";
import "./StatutoryWarning.css"; // Renamed from Blog.css
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { StatutoryWarningContext } from "../context/StatutoryWarningContext"; // Changed from BlogContext

function StatutoryWarning() {
    const PAGE_SIZE = 5;
    const [page, setPage] = useState(1);
    const navigate = useNavigate();

    // Using both contexts
    const { user, logout } = useContext(AuthContext);
    const { statutoryWarnings, loading, fetchNextPage, hasMore, deleteWarningFromState } = useContext(StatutoryWarningContext);

    const totalLoadedPages = Math.ceil((statutoryWarnings.length || 0) / PAGE_SIZE);

    const handleNext = async () => {
        if (page + 1 > totalLoadedPages && hasMore) {
            await fetchNextPage();
        }
        setPage(page + 1);
    };

    const handlePrev = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleAddStatutoryWarningClick = () => {
        if (user) {
            navigate("/statutory-warning-add"); // Changed from /blog-add
        } else {
            Swal.fire({
                icon: "info",
                title: "Admin Login Required",
                text: "Please login as admin to add a statutory warning.", // Changed text
                confirmButtonText: "Go to Admin Login",
            }).then(() => navigate("/admin-login"));
        }
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d32f2f",
            cancelButtonColor: "#888",
            confirmButtonText: "Yes, delete it!",
        });
        if (!result.isConfirmed) return;
        try {
            await deleteDoc(doc(db, "statutory-warnings", id)); // Changed collection to "statutory-warnings"
            deleteWarningFromState(id);
            Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: "Statutory warning has been deleted.", // Changed text
                timer: 1200,
                showConfirmButton: false,
            });
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Failed to delete statutory warning", // Changed text
                text: err.message,
            });
        }
    };

    const createSnippet = (htmlString, maxLength) => {
        if (!htmlString) return "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlString;
        if (tempDiv.textContent.length <= maxLength) {
            return htmlString;
        }
        let truncatedHtml = "";
        let charCount = 0;
        const openTags = [];
        const parts = htmlString.split(/(<[^>]+>)/);
        for (const part of parts) {
            if (part.startsWith("<")) {
                if (part.startsWith("</")) {
                    openTags.pop();
                } else if (!part.endsWith("/>")) {
                    const tagName = part.match(/<([a-zA-Z0-9]+)/);
                    if (tagName) {
                        openTags.push(tagName[1]);
                    }
                }
                truncatedHtml += part;
            } else {
                if (charCount < maxLength) {
                    const remaining = maxLength - charCount;
                    if (part.length > remaining) {
                        truncatedHtml += part.substring(0, remaining);
                        charCount = maxLength;
                    } else {
                        truncatedHtml += part;
                        charCount += part.length;
                    }
                }
            }
            if (charCount >= maxLength) break;
        }
        truncatedHtml += "...";
        while (openTags.length > 0) {
            truncatedHtml += `</${openTags.pop()}>`;
        }
        return truncatedHtml;
    };

    const paginatedStatutoryWarnings = statutoryWarnings.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    return (
        <div className="statutory-warning-container"> {/* Renamed CSS class */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20,
                }}
            >
                <h2>Recent Statutory Warnings</h2> {/* Changed text */}
                <div className="admin-buttons">
                    {user && (
                        <>
                            <button className="button" onClick={handleAddStatutoryWarningClick}>
                                Add Statutory Warning {/* Changed text */}
                            </button>
                            <button
                                className="button"
                                style={{ background: "#d32f2f", marginLeft: "10px" }}
                                onClick={logout}
                            >
                                Logout
                            </button>
                        </>
                    )}
                </div>
            </div>

            {loading && statutoryWarnings.length === 0 ? (
                <p>Loading...</p>
            ) : (
                <ul className="statutory-warning-list"> {/* Renamed CSS class */}
                    {paginatedStatutoryWarnings.map((statutoryWarning) => (
                        <li
                            key={statutoryWarning.id}
                            className="statutory-warning-item" /* Renamed CSS class */
                            style={{
                                display: "grid",
                                gridTemplateColumns: "auto 1fr",
                                gap: "16px",
                                alignItems: "center",
                            }}
                        >
                            <div style={{ width: "80px", aspectRatio: "1 / 1" }}>
                                <img
                                    src={statutoryWarning.imageUrl || "https://via.placeholder.com/80"}
                                    alt="statutory warning" // Changed alt text
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: 8,
                                        objectFit: "cover",
                                    }}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <h3>{statutoryWarning.title}</h3>
                                <div
                                    className="statutory-warning-item-snippet" /* Renamed CSS class */
                                    dangerouslySetInnerHTML={{
                                        __html: createSnippet(statutoryWarning.content, 120),
                                    }}
                                    style={{ flexGrow: 1 }}
                                />
                                <div
                                    style={{
                                        fontSize: 14,
                                        color: "#555",
                                        marginTop: 5,
                                        marginBottom: 5,
                                    }}
                                >
                                    {statutoryWarning.date && statutoryWarning.date.seconds
                                        ? new Date(
                                            statutoryWarning.date.seconds * 1000
                                        ).toLocaleDateString()
                                        : ""}
                                    <span> </span>
                                    {statutoryWarning.date && statutoryWarning.date.seconds
                                        ? new Date(
                                            statutoryWarning.date.seconds * 1000
                                        ).toLocaleTimeString()
                                        : ""}
                                </div>
                                <div>
                                    <button
                                        className="button"
                                        style={{ marginLeft: 0, fontSize: 14 }}
                                        onClick={() => navigate(`/statutory-warning/${statutoryWarning.id}`)} // Changed route
                                    >
                                        Read More
                                    </button>
                                    {user && (
                                        <button
                                            className="button"
                                            style={{
                                                marginLeft: 8,
                                                background: "#d32f2f",
                                                fontSize: 14,
                                            }}
                                            onClick={() => handleDelete(statutoryWarning.id)}
                                        >
                                            Delete
                                        </button>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
            {statutoryWarnings.length > 0 && (
                <div className="pagination">
                    <button
                        onClick={handlePrev}
                        className="button"
                        disabled={page === 1}
                    >
                        <span className="pagination-arrow">&lt;</span>
                        <span className="pagination-text"> Previous</span>
                    </button>
                    <span>Page {page}</span>
                    <button
                        onClick={handleNext}
                        className="button"
                        disabled={page >= totalLoadedPages && !hasMore}
                    >
                        <span className="pagination-text">Next </span>
                        <span className="pagination-arrow">&gt;</span>
                    </button>
                </div>
            )}
        </div>
    );
}

export default StatutoryWarning; // Changed export